import { createAction } from 'redux-act'

export const checkToken = createAction('Check Token Request')
export const verifyToken = createAction('Verify Token Request')

export const setSession = createAction('Set Session')
export const removeSession = createAction('Remove Session')
export const setLanguage = createAction('Set Language By Updated Language')

